import { render } from "./ContractUpdateList.vue?vue&type=template&id=7940daa2"
import script from "./ContractUpdateList.vue?vue&type=script&lang=js"
export * from "./ContractUpdateList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__